import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "../site/Motion";
import { ProjectDialog } from "../site/ProjectDialog";
import { useProjects } from "../../lib/useProjects";
import { img } from "../../lib/api";

export const FeaturedWeddings = () => {
  const { items, loading } = useProjects("wedding");
  const [open, setOpen] = useState(null);
  const sorted = [...items].sort((a, b) => Number(b.featured) - Number(a.featured));
  const photos = sorted.flatMap((p) => (p.images || []).map((u) => ({ src: u, project: p })));

  return (
    <section data-testid="featured-weddings-section" className="bg-cream">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-24 sm:py-32">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14">
          <div>
            <Eyebrow>Portfolio wedding</Eyebrow>
            <Reveal><h2 className="mt-4 font-serif text-5xl sm:text-7xl text-ink leading-none">Matrimoni <em className="text-cypress">in fiore</em></h2></Reveal>
            <Reveal delay={0.1}><p className="mt-5 max-w-xl text-ink/75">Una raccolta di foto dai miei eventi, aggiornata di volta in volta: allestimenti, bouquet e dettagli.</p></Reveal>
          </div>
          <Link to="/portfolio" data-testid="featured-all-link" className="inline-flex items-center gap-2 text-sm text-cypress link-underline shrink-0">Tutti i progetti <ArrowUpRight className="w-4 h-4" /></Link>
        </div>
        {loading ? (
          <p className="text-ash">Caricamento…</p>
        ) : photos.length === 0 ? (
          <p className="text-ash">Nuovi progetti in arrivo.</p>
        ) : (
          <div data-testid="weddings-gallery" className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:balance]">
            {photos.map((ph, i) => (
              <motion.button
                key={ph.src + i}
                type="button"
                onClick={() => setOpen(ph.project)}
                data-testid={`wedding-photo-${i}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: (i % 3) * 0.07 }}
                className="group relative block w-full mb-5 break-inside-avoid overflow-hidden bg-sand"
              >
                <img src={img(ph.src)} alt={ph.project.title} loading="lazy"
                  className="w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.05]" />
              </motion.button>
            ))}
          </div>
        )}
      </div>
      <ProjectDialog project={open} onClose={() => setOpen(null)} />
    </section>
  );
};
